import { PageLayout } from '../components/PageLayout';

export function Privacy() {
  return (
    <PageLayout
      title="Privacy Policy"
      metaTitle="Privacy Policy - Abrovinc"
      metaDescription="Learn how Abrovinc collects, uses, and protects your personal information. Our privacy policy outlines our commitment to data security and your privacy rights."
      metaKeywords="privacy policy, data protection, GDPR, personal information, data security, Abrovinc"
      metaUrl="https://abrovinc.com/privacy"
    >
      <p>
        <strong>Last updated:</strong> {new Date().getFullYear()}
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        When you visit our website or contact us for our IT consultancy services, we may collect the
        following types of information:
      </p>
      <ul>
        <li>
          <strong>Personal Information:</strong> Name, email address, phone number, and company
          information when you contact us
        </li>
        <li>
          <strong>Usage Data:</strong> Information about how you use our website, including IP
          address, browser type, and pages visited
        </li>
        <li>
          <strong>Cookies:</strong> We use cookies to improve your experience on our website
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Provide and improve our IT consultancy services</li>
        <li>Communicate with you about our services</li>
        <li>Respond to your inquiries and requests</li>
        <li>Analyze website usage to improve user experience</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h2>3. Information Sharing</h2>
      <p>
        We do not sell, trade, or otherwise transfer your personal information to third parties
        without your consent, except in the following circumstances:
      </p>
      <ul>
        <li>When required by law or legal process</li>
        <li>To protect our rights, property, or safety</li>
        <li>With your explicit consent</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We implement appropriate security measures to protect your personal information against
        unauthorized access, alteration, disclosure, or destruction. However, no method of
        transmission over the internet is 100% secure.
      </p>

      <h2>5. Cookies</h2>
      <p>
        Our website uses cookies to enhance user experience. You can choose to disable cookies
        through your browser settings, but this may affect the functionality of our website.
      </p>

      <h2>6. Your Rights</h2>
      <p>Under applicable data protection laws, you may have the right to:</p>
      <ul>
        <li>Access your personal information</li>
        <li>Correct inaccurate information</li>
        <li>Request deletion of your information</li>
        <li>Object to processing of your information</li>
        <li>Request data portability</li>
      </ul>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or our data practices, please contact us
        at:
        <br />
        Email: info@abrovinc.com
        <br />
        Address: Umeå, Sweden
      </p>
    </PageLayout>
  );
}
